import axios from "axios";

export const getUserCountry = async () => {
    try {
        const res = await axios.get("https://ipapi.co/json/");

        return {
            country: res.data.country_name,
            iso2: res.data.country_code,
            dialCode: res.data.country_calling_code
        };
    } catch (error) {
        console.error("IP detection failed", error);
        return null;
    }
};